import { render, staticRenderFns } from "./jk.vue?vue&type=template&id=33458881&"
import script from "./jk.vue?vue&type=script&lang=js&"
export * from "./jk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports